import { observable, action } from 'mobx'
import { IErrorType } from '@prisma/studio-types'

import TelemetryStore from 'stores/telemetry/TelemetryStore'

interface IErrorCreatePayload {
  type: IErrorType
  description: string | null /* A small explanation of the error */
  dump: string | null /* Dump of the error, can be as huge as needed */
}

class ErrorStore {
  @observable type: IErrorType = 'fatal'
  @observable description: IErrorCreatePayload['description'] = null
  @observable dump: IErrorCreatePayload['dump'] = null

  @action
  update(error: IErrorCreatePayload) {
    this.type = error.type
    this.description = error.description
    this.dump = error.dump

    TelemetryStore.send({
      command: 'error_throw',
      commandDetails: {
        type: this.type,
        description: this.description,
      },
    })
  }
}

export default new ErrorStore()
